import { useSelector } from 'store/hooks/useSelector'

const selectEmail = (state: Store) => state.waitingRoomReducer.providerProfile.Email
const selectFlags = (state: Store) => state?.flags?.flags ?? {}

export function useSentryFeedbackFlag(): boolean {
  const email = useSelector(selectEmail)
  const flags = useSelector(selectFlags)
  const emailLower = email?.toLowerCase() ?? ''
  return Boolean(
    flags?.sentry_feedback_provider?.active &&
    (flags?.sentry_feedback_provider?.emails?.length === 0 ||
      flags?.sentry_feedback_provider?.emails?.some((e) => e.toLowerCase() === emailLower)),
  )
}
